import { FaSpinner } from "react-icons/fa";

import { useUIStateStore } from "@/store/uiStateStore";

import useSiteConfigAuth from "../api/sanity/queries/getSiteConfigWithCode";
import useGetColours from "../helpers/getColours";

function ButtonDashboard(props) {
  const { data: siteConfig } = useSiteConfigAuth();
  const isTunecore = useUIStateStore(state => state.isTunecore);
  const { highlightColour } = useGetColours(siteConfig);
  const {
    children,
    onClick,
    disabled,
    pending,
    id,
  } = props;

  return (
    <>
      <>
        {!isTunecore ? (
          <button
            id={id}
            style={{ backgroundColor: highlightColour }}
            disabled={disabled}
            type="button"
            className="w-full h-16 py-4 mb-2 text-sm font-medium tracking-tight uppercase transition-all duration-150 ease-linear rounded-lg shadow outline-none disabled:opacity-25 disabled:text-gray-400 disabled:pointer-events-none text-sentric-rebrand-dark-grey font-sentric-alt x-8 hover:shadow-lg disabled:shadow-none focus:outline-none hover:scale-105"
            onClick={onClick}
          >
            {children}
            {pending && <FaSpinner className="inline ml-3 text-white animate-spin" />}
          </button>
        ) : (
          <button
            id={id}
            disabled={disabled}
            type="button"
            style={{
              background: `linear-gradient(to bottom right, #00ef86, #008eb9)`,
              borderRadius: "50px",
              padding: "12px 20px",
            }}
            className="w-full h-16 mb-2 text-sm font-medium text-white uppercase border-none rounded-full font-sentric-alt x-8 tunecore-button-primary"
            onClick={onClick}
          >
            {children}
            {pending && <FaSpinner className="inline ml-3 text-white animate-spin" />}
          </button>
        )}
      </>
    </>
  );
}

export default ButtonDashboard;
